/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import errorSVG from '@/assets/img/error.svg'
import { FormattedMessage } from 'react-intl'
import { Button } from './ui/button'
import { Link, useRouter } from '@tanstack/react-router'
import { BUTTON_VARIANTS, cn } from '../lib/utils'
import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import { useEffect } from 'react'

function getErrorMessage(err: string) {
  try {
    const parseError = JSON.parse(err)
    return parseError.message as string
  } catch (error) {
    return null
  }
}

type Props = {
  error: Error
  customMessage?: boolean
}
export function ErrorComponent({ error, customMessage = false }: Props) {
  const router = useRouter()
  const queryErrorResetBoundary = useQueryErrorResetBoundary()
  const errorMessage = getErrorMessage(error.message)

  useEffect(() => {
    queryErrorResetBoundary.reset()
  }, [queryErrorResetBoundary])
  return (
    <div className='grid h-full w-full place-items-center'>
      <div className='mt-[8%] flex flex-col gap-3 px-4'>
        <div className='mx-auto'>
          <img src={errorSVG} alt='' />
        </div>
        <h1 className='text-center font-bold'>
          <FormattedMessage id='common.errorTitle' />
        </h1>
        <p className='text-center'>
          {customMessage ? (
            errorMessage ?? error.message
          ) : (
            <FormattedMessage id='common.errorDescription' />
          )}
        </p>
        <div className='flex items-center justify-center gap-3'>
          <Button
            variant={'accent'}
            onClick={() => {
              queryErrorResetBoundary.reset()
              void router.invalidate()
            }}
          >
            <FormattedMessage id='common.tryAgain' />
          </Button>
          <Link
            className={cn(BUTTON_VARIANTS({ variant: 'accent' }))}
            to='/dashboard'
          >
            <FormattedMessage id='common.backToHome' />
          </Link>
        </div>
      </div>
    </div>
  )
}
